<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("edit") }} {{ $tc("designation", 2) }}
      </div>
      <div>
        <router-link class="btn-blue" to="designations"
          >{{ $tc("designation", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Designations"
          :key="index"
          v-if="item.fieldname !== 'designation_id'"
          class="col-lg-6 col-xl-4 align-self-center"
        >
          <div v-if="item.fieldname !== 'designation_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>
          <div v-if="item.fieldname === 'designation_is_active'">
            <div class="row">
              <div class="col-md-3 col-xl-2 align-self-center">
                <label class="mb-0">{{ $t("active") }}</label>
              </div>
              <div class="col-md-9 col-xl-10 align-self-center">
                <label class="j-checkbox mb-0">
                  <b-form-checkbox
                    type="checkbox"
                    class="j-checkbox"
                    v-model="item.fieldvalue"
                  ></b-form-checkbox>
                  <span class="switch-slider"></span>
                </label>
              </div>
            </div>
            <p class="error_message"></p>
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onUpdateHandler"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="resetHandler"
            class="btn-black"
          >
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="designations"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Designations from "@/helper/formJSONMaster/Designations";

export default {
  data() {
    return {
      btenable: false,
      Designations: Designations.ms_designations,

      Methods: Designations.Methods,
      submitted: false,
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    console.log("id :", id);
    if (id) {
      this.getEditList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    onFocusHandler: function () {
      // this.submitted = false;
    },
    resetHandler: function () {
      this.Designations.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    getEditList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      console.log("body :", body);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("data :", data);
            let obj = data.details[0];
            this.Designations.map((x) => {
              if (x.fieldname === "designation_is_active") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onUpdateHandler: function () {
      // changed
      // let body = this.getRequestBody("PUT", this.Designations, {
      //   ...this.Methods,
      //   params: { id: this.$route.query.id }
      // });
      // MasterService.GlobalRequest(body)
      //   .then(response => {
      //     const { data } = response;
      //     if (data.status) {
      //       console.log("here :", data);
      //       this.$router.push({
      //         path: "/master/designations"
      //       });
      //     } else {
      //       console.log("show error :", data.message);
      //       this.$toasted.show(Error(data.message));
      //     }
      //   })
      //   .catch(error => {
      //     console.log("show error :", error);
      //   });
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;

          console.log("valid :", valid);
          let body = this.getRequestBody("PUT", this.Designations, {
            ...this.Methods,
            params: { id: this.$route.query.id },
          });
          console.log("body :", body);

          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;

              if (data.status) {
                console.log("here :", data);
                this.$router.push({
                  path: "/user-management/designations",
                });
              } else {
                console.log("show error :", data.message);
                this.$toasted.show(Error(data.message));
              }
            })
            .catch((error) => {
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/UserManagement/DesignationsComponents/editDesignation.vue